import { addSideEffects } from '@poa/state';
import { clone } from '../shared/clone';
import {
  setAccountFavorite,
  fetchGeneralProfile,
  fetchGeneralProfileChildren,
  fetchGeneralProfiles,
  fetchGeneralReports,
  updateGeneralProfile,
  createTransfer,
  updateTransfer,
  setDates,
  sendProfileAction
} from './general.actions';


async function fetchGeneralProfilesFilterRequest(env, {
  filter_by = null,
  page = 1,
  search = null,
  is_favorite = false,
  page_size = 25,
  startDate,
  endDate
}) {
  return env.api.generalProfiles.fetchGeneralProfiles(
    filter_by,
    page,
    search,
    is_favorite,
    page_size,
    startDate.toISOString(),
    endDate.toISOString()
  );
}

// fetch
addSideEffects(fetchGeneralProfile, async ({ id }, { actions, env, store }) => {
  try {
    const response = await env.api.generalProfiles.fetchProfile(id);
    actions.generalProfileActions.fetchGeneralProfileSuccess(response);
  } catch (e) {
    console.error(e);
    actions.generalProfileActions.fetchGeneralProfileFailed(e);
    throw e;
  }
});


addSideEffects(fetchGeneralProfiles, async ({
  filter_by,
  page,
  search,
  isFavorite,
  page_size,
}, { actions, env, store }) => {
  try {
    const { startDate, endDate } = store.generalProfile.filters;
    const profiles = await fetchGeneralProfilesFilterRequest(env, {
      filter_by: filter_by,
      page: page,
      search: search,
      is_favorite: isFavorite,
      page_size: page_size,
      startDate: startDate,
      endDate: endDate,
    });
    actions.generalProfileActions.fetchGeneralProfilesSuccess(profiles);
  } catch (e) {
    console.error(e);
    actions.generalProfileActions.fetchGeneralProfilesFailed();
    throw e;
  }
});

addSideEffects(fetchGeneralProfileChildren, async ({ id }, { actions, env, store }) => {
  try {

    const startDate = store.generalProfile.filters.startDate;
    const endDate = store.generalProfile.filters.endDate;
    const profile_children = await env.api.generalProfiles.fetchGeneralProfileChildren(
      id,
      startDate,
      endDate
    );
    actions.generalProfileActions.fetchGeneralProfileChildrenSuccess(profile_children, id);
  } catch (e) {
    console.error(e);
    actions.generalProfileActions.fetchGeneralProfileChildrenFailed();
    throw e;
  }
}
);

addSideEffects(updateGeneralProfile, async ({ id, data }, { actions, env }) => {
  try {
    const response = await env.api.generalProfiles.updateGeneralProfile(id, data);
    actions.generalProfileActions.updateGeneralProfileSuccess(response);
    env.alert('Успех', `Данные успешно обновлены`);
  } catch (e) {
    console.error(e);
    env.alert(
      'Ошибка',
      `Ошибка. Данные не обновились.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
    );
  }
});


addSideEffects(sendProfileAction, async ({ id, action }, { actions, env }) => {
  try {
    await env.api.generalProfiles.sendProfileAction(id, action);
    env.alert('Успех', `Вы успешно отправили действие ${action} для профиля с ID: ${id}`);
  } catch (e) {
    console.error(e);
    env.alert(
      'Ошибка',
      `Ошибка<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
    );
  }
});


addSideEffects(createTransfer, async ({ data }, { actions, env }) => {
  try {
    const response = await env.api.generalProfiles.createTransfer(data);
    actions.generalProfileActions.createTransferSuccess(response);
    env.alert('Успех', `Трансфер успешно создан`);
  } catch (e) {
    console.error(e);
    env.alert(
      'Ошибка',
      `Ошибка. Трансфер не создан.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
    );
  }
});


addSideEffects(updateTransfer, async ({ data }, { actions, env }) => {
  try {
    const response = await env.api.generalProfiles.updateTransfer(data);
    actions.generalProfileActions.updateTransferSuccess(response);
    env.alert('Успех', `Трансфер успешно обновлен`);
  } catch (e) {
    console.error(e);
    env.alert(
      'Ошибка',
      `Ошибка. Трансфер не обновлен.<br /><br /> Тип ошибки: <br />${e.response.data.error_message}`
    );
  }
});

addSideEffects(setDates, async ({ startDate, endDate }, { actions, env, store }) => {
  await env.storage.setItem('general-dates', clone({ startDate, endDate }));
  store.generalProfile.filters.startDate = startDate;
  store.generalProfile.filters.endDate = endDate;
});


addSideEffects(setAccountFavorite, async ({ id }, { actions, env, store }) => {
  try {
    await env.api.generalProfiles.setAccountFavorite(id)
  } catch (e) {
    console.error(e);
    throw e;
  }
});


addSideEffects(fetchGeneralReports, async (payload, { actions, env }) => {
  try {
    const reports = await env.api.accounts.fetchAccountReports(payload.id);
    actions.generalProfileActions.fetchGeneralReportsSuccess(reports);
  } catch (e) {
    console.error(e);
    env.alert('Ошибка', `${e.response.data.error_message}`);
  }
});